/** Brand AbilitySpec seed kit (wiki-aligned numeric batch 1). */
export const BRAND_ABILITY_DEFS = [
  {
    id: 'brand_q',
    champKey: 'brand',
    slot: 'Q',
    name: 'Sear',
    targeting: 'skillshot_line',
    range: 1100,
    castTime: 0.25,
    travelSpeed: 1600,
    width: 120,
    radius: 60,
    cooldown: 8,
    manaCost: 70,
    vfxId: 'brand_q',
    status: 'wired'
  },
  {
    id: 'brand_w',
    champKey: 'brand',
    slot: 'W',
    name: 'Pillar of Flame',
    targeting: 'ground_aoe',
    range: 900,
    castTime: 0.25,
    effectDelay: 0.627,
    travelSpeed: null,
    width: null,
    radius: 260,
    cooldown: 10,
    manaCost: 60,
    vfxId: 'brand_w',
    status: 'wired'
  },
  {
    id: 'brand_e',
    champKey: 'brand',
    slot: 'E',
    name: 'Conflagration',
    targeting: 'targeted',
    range: 675,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: 300,
    cooldown: 13,
    manaCost: 90,
    vfxId: 'brand_e',
    status: 'wired'
  },
  {
    id: 'brand_r',
    champKey: 'brand',
    slot: 'R',
    name: 'Pyroclasm',
    targeting: 'targeted',
    range: 750,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: 600,
    cooldown: 100,
    manaCost: 100,
    vfxId: 'brand_r',
    status: 'wired'
  }
];
